var post_popup_confirmations = ( function( $ ) {

	var $popup;

	var cookie_prefix = 'post-popup-confirmation-accepted-';

	var _init = function() {
		$popup = $( '#post-popup' );

		if ( _popup_is_for_current_post() ) {
			_maybe_open_popup_from_current_post();
		}

		var $post_cards_with_popup = $( '[data-popup]' );

		if ( $post_cards_with_popup.length > 0 ) {
			$post_cards_with_popup.on( 'click', _maybe_open_popup_from_post_card );
		}

		$popup.find( '.button' ).on( 'click', _handle_submit );
	};

	var _maybe_open_popup_from_post_card = function( e ) {
		var $this      = $( this );
		var popup_data = JSON.parse( decodeURIComponent( $this.attr( 'data-popup' ) ) );

		if ( _cookie_applied_for_post( popup_data.blog_id, popup_data.post_id ) ) {
			return;
		}

		e.preventDefault();
		_set_popup_content( popup_data );
		_open_popup( true );
	};

	var _maybe_open_popup_from_current_post = function( e ) {
		var blog_id = $popup.find( '.button' ).attr( 'data-blog' );
		var post_id = $popup.find( '.button' ).attr( 'data-post' );

		if ( !_cookie_applied_for_post( blog_id, post_id ) ) {
			_open_popup( false );
		}
	};

	var _open_popup = function( closeable ) {
		var popup_object = {
			items: {
				src: '#post-popup'
			},
			type: 'inline',
			removalDelay: 300,
			mainClass: 'post-popup-in',
			preloader: false,
			callbacks: {
				beforeOpen: function() {
					if ( $( window ).width() < 700 ) {
						this.st.focus = false;
					} else {
						this.st.focus = '#name';
					}
				}
			}
		};

		if ( !closeable ) {
			popup_object.closeOnContentClick = false;
			popup_object.closeOnBgClick      = false;
			popup_object.enableEscapeKey     = false;
			popup_object.showCloseBtn        = '';
		}

		$.magnificPopup.open( popup_object );
	};

	var _set_popup_content = function( content ) {
		var $title        = $popup.find( '.popup-title' );
		var $instructions = $popup.find( '.instructions' );
		var $checkboxes   = $popup.find( '.checkboxes' );
		var $button       = $popup.find( '.button' );

		$popup.attr( 'data-on-post', 0 );
		$title.empty();
		$instructions.empty();
		$checkboxes.empty();
		$button.attr( 'href', '' );
		$button.attr( 'data-post', '' );
		$button.attr( 'data-blog', '' );

		if ( 'title' in content ) {
			$title.text( content.title );
		}

		if ( 'instructions' in content ) {
			$instructions.text( content.instructions );
		}

		if ( 'checkboxes' in content && Array.isArray( content.checkboxes ) ) {
			var checkbox_html = '';

			content.checkboxes.forEach( function( checkbox, index ) {
				var name = 'checkbox-' + index;

				checkbox_html += '<div class="checkbox">'
					+ '<input name="' + name + '" id="' + name + '" type="checkbox">'
					+ '<label for="' + name + '">' + checkbox.checkbox + '</label>'
					+ '</div>'
			} );

			$checkboxes.html( checkbox_html );
		}

		if ( 'post_url' in content ) {
			$button.attr( 'href', content.post_url );
		}

		if ( 'post_id' in content ) {
			$button.attr( 'data-post', content.post_id );
		}

		if ( 'blog_id' in content ) {
			$button.attr( 'data-blog', content.blog_id );
		}

		$popup.find( '.error-message' ).css( 'display', 'none' );
	};

	var _handle_submit = function( e ) {
		var $verified = _verify_checkboxes( e );

		if ( $verified ) {
			_apply_cookie( $( this ) );
			$.magnificPopup.close();

			if ( _popup_is_for_current_post() ) {
				e.preventDefault();
			}
		}
	};

	var _verify_checkboxes = function( e ) {
		var $unchecked = $popup.find( '.checkboxes' ).find( 'input:checkbox:not(:checked)' );

		if ( $unchecked.length > 0 ) {
			e.preventDefault();

			$popup.find( '.error-message' ).slideDown();

			return false;
		}

		return true;
	};

	var _apply_cookie = function( $this ) {
		var post_id = $this.attr( 'data-post' );
		var blog_id = $this.attr( 'data-blog' );

		if ( !_cookie_applied_for_post( blog_id, post_id ) ) {
			$.cookie( cookie_prefix + blog_id + '-' + post_id, 'true', { expires: 14, path: '/' } );
		}
	};

	var _cookie_applied_for_post = function( blog_id, post_id ) {
		return $.cookie( cookie_prefix + blog_id + '-' + post_id );
	};

	var _popup_is_for_current_post = function() {
		return $popup.attr( 'data-on-post' ) == 1;
	};

	if ( $( '#post-popup' ).length > 0 ) {
		_init();
	}

	return {};

} )( jQuery );

module.exports = post_popup_confirmations;